module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-error-c1b4228ac18ebc53a7cb2676673a0eb3.svg";